export default {
  init() {
    $('.js-callback-btn').on('click',function(){
      $('.CallBackBlock').toggleClass('CallBackBlock--visible');
      $(this).toggleClass('js-callback-btn--visible');
      $('.EstimateBlock').removeClass('EstimateBlock--visible');
    });

    // $('.js-estimate-btn').on('click',function(){
    //   $('.EstimateBlock').toggleClass('EstimateBlock--visible');
    //   $('.CallBackBlock').removeClass('CallBackBlock--visible');
    //   $('.js-callback-btn').removeClass('js-callback-btn--visible');
    //   $('.main').toggleClass('main--overlay');
    // });

    $('.js-close-cross').on('click',function(){
      $('.EstimateBlock').removeClass('EstimateBlock--visible');
      $('.main').removeClass('wrap--overlay');
    });

    $('input').on('focus',function(){
      $(this).removeClass('wpcf7-not-valid');
      $(this).next().css('display','none');
    });

    $('textarea').on('focus',function(){
      $(this).removeClass('wpcf7-not-valid');
      $(this).next().css('display','none');
    });

    // $('main').on('click',function(){
    //   $('.CallBackBlock').removeClass('CallBackBlock--visible');
    //   $('.EstimateBlock').removeClass('EstimateBlock--visible');
    // })

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js